import { makeRequest } from '../utils/apiUtils';

export const GET_SELECT_LIST = 'selectList/GET_SELECT_LIST';
export const GET_SELECT_LIST_SUCCESS = 'selectList/GET_SELECT_LIST_SUCCESS';
export const GET_SELECT_LIST_FAIL = 'selectList/GET_SELECT_LIST_FAIL';

export function getSelectList(name, search) {
  return makeRequest(`/saduka/selectList/${name}?name=${search}`, {
    types: [GET_SELECT_LIST, GET_SELECT_LIST_SUCCESS, GET_SELECT_LIST_FAIL],
    options: {
      credentials: 'include'
    },
    name
  });
}
